import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m40 35.65-3-3V19.3H23.65l-3-3h9.85v-4.75q0-2.75-1.975-4.65Q26.55 5 23.8 5 21 5 19.075 6.925 17.15 8.85 17.15 11.55v1.25l-2.75-2.75q.45-3.5 3.125-5.775Q20.2 2 23.8 2q4.05 0 6.875 2.775T33.5 11.55v4.75H37q1.25 0 2.125.875T40 19.3ZM11 44q-1.25 0-2.125-.875T8 41V19.3q0-1.15.8-2.025t1.95-.975L.35 5.9q-.45-.45-.425-1.05.025-.6.475-1.05.45-.45 1.05-.45.6 0 1.05.45l41.95 41.95q.45.45.425 1.05-.025.6-.475 1.05-.45.45-1.05.45-.6 0-1.05-.45l-4.1-4.1q-.4.15-.65.2-.25.05-.55.05Zm24.5-3-8.75-8.7q-.55.55-1.2.8-.65.25-1.45.25-1.6 0-2.675-1.05-1.075-1.05-1.075-2.65 0-.8.275-1.475t.825-1.225l-7.7-7.65H11V41ZM24.65 30.15Zm5.65-4.2Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }